import Shop from '@/components/page/shopPage'

export default Shop
